<template>
  <div class="modal fade text-left" :id="followedSearchId" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="show !== false" class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <template v-if="followedSearch">
            <h4 class="modal-title">Edit : {{followedSearch.search_terms.term}}</h4>
          </template>
          <template v-else>
            <h4 class="modal-title">Monitor keywords</h4>
          </template>
          <div>Experts can be monitored using Explore Science & Technology</div>
        </div>
        <form v-on:submit="save">

          <div class="modal-body">
            <div class="row" style="margin-top: 15px">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label required" for="followedSearch">Search</label>
                  <div class="row">
                    <div class="col-xs-12">
                      <simple ref="search" id="followedSearch" v-model="query"
                              :placeholder="'Enter search topics in English, e.g. image sensor'" :help-keywords="true" :in-modal="true"></simple>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-6">
                <div class="form-group">
                  <label class="control-label required" for="searchType">Search Type</label>
                  <v-select2 id="searchType" :options="searchTypes" label="name" v-model="searchTypeSelected"
                             :dropdownParent="followedSearchId" required></v-select2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-6">
                <div class="form-group">
                  <label class="control-label required" for="frequency">Frequency</label>
                  <v-select2 id="frequency" :options="frequencies" label="name" v-model="frequencySelected"
                             :dropdownParent="followedSearchId" required></v-select2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="m-t-sm">You will receive regular updates on your topic of interest</div>
              </div>
            </div>

            <div style="text-align: right;margin-top: 10px">
              <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
            </div>
          </div>
          <div class="modal-footer">
            <template v-if="followedSearch">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
            </template>
            <template v-else>
              <div class="row text-center">
                <div class="col-xs-12 col-md-4 m-t-xs">
                  <button type="button" class="btn btn-default btn-block" data-dismiss="modal">Cancel</button>
                </div>
                <div class="col-xs-12 col-md-4 m-t-xs">
                  <vue-ladda type="submit" :loading="submit.loading" class="btn btn-outline btn-info btn-block" :data-style="submit.dataStyle" name="save">Save keywords monitoring</vue-ladda>
                </div>
                <div class="col-xs-12 col-md-4 m-t-xs">
                  <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info btn-block" :data-style="submit.dataStyle" name="explore">Explore Science & Technology</vue-ladda>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-xs-12 col-md-offset-8 col-md-4">
                  Your keyword monitoring is automatically saved
                </div>
              </div>
            </template>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<style>
  #input-group-tagsinput {
    width: 100%;
  }
</style>
<script>

import vSelect2 from '../../components/utils/select2'
import Simple from '../../components/search/Simple'
import VueLadda from 'vue-ladda'
import {cleanQueryFromTagsinputToSearch, formatSearchForUrl} from '../../assets/scripts/search'

export default {
  name: 'EditFollowedSearch',
  components: {
    VueLadda,
    vSelect2,
    Simple
  },
  data () {
    return {
      show: false,
      followedSearchId: null,
      followedSearch: null,
      query: null,
      frequencies: [{id: 0, name: '1_MONTH'}, {id: 2, name: '3_MONTH'}, {id: 3, name: '6_MONTH'}, {id: 4, name: '12_MONTH'}],
      searchTypes: [{id: 0, name: 'Science'}, {id: 1, name: 'Patent'}],
      frequencySelected: null,
      searchTypeSelected: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      let query = this.$refs.search.getQuery()
      let data = {}
      if (this.followedSearch === null) {
        data.search = cleanQueryFromTagsinputToSearch(query)
        data.search_type = this.searchTypeSelected.id
        data.frequency = this.frequencySelected.name
      } else {
        data = this.followedSearch
        data.search_terms.term = cleanQueryFromTagsinputToSearch(query)
        data.search_type = typeof this.searchTypeSelected.id !== 'undefined' ? this.searchTypeSelected.id : this.searchTypeSelected
        data.frequency = this.frequencySelected.name
      }

      if (query !== null) {
        this.submit.loading = true
        if (this.followedSearch === null) {
          this.axios.post('follow/search/', data).then(() => {
            this.$notify({
              type: 'success',
              title: '',
              content: 'Monitoring action saved',
              placement: 'bottom-right'
            })

            $('#' + this.followedSearchId).modal('hide')

            if (e !== null && typeof e.submitter !== 'undefined' && e.submitter.name === 'explore') {
              this.$router.push({ name: 'SearchSimple', params: {query: query}})
            }
            this.frequencySelected = null
            this.searchTypeSelected = null
            this.query = null
          }).catch((error) => {
          }).finally(() => {
            this.submit.loading = false
          })
        } else {
          this.axios.patch('follow/search/' + this.followedSearch.id, data).then(() => {
            this.$notify({
              type: 'success',
              title: '',
              content: 'Monitoring action saved',
              placement: 'bottom-right'
            })

            $('#editFollowedSearch-' + this.followedSearch.id).modal('hide')
          }).catch((error) => {
          }).finally(() => {
            this.submit.loading = false
          })
        }
      }
    },
    openModal: function () {
      this.show = true

      this.followedSearchId = 'editFollowedSearch'
      if (this.followedSearch !== null) {
        this.followedSearchId += '-' + this.followedSearch.id
      }
      setTimeout(() => {
        $('#' + this.followedSearchId).modal('show')

        $('#' + this.followedSearchId).on('hide.bs.modal', () => {
          this.show = false
          this.frequencySelected = null
          this.searchTypeSelected = null
          this.followedSearchId = null
          this.query = null
          this.$emit('onClose', true)
        })
      }, 200)
    },
    setFollowedSearch: function (followedSearch) {
      this.followedSearch = followedSearch

      if (followedSearch !== null) {
        this.query = followedSearch.search_terms.term

        this.query = formatSearchForUrl(this.query)

        this.searchTypeSelected = followedSearch.search_type
        this.frequencySelected = this.frequencies.find((frequency) => {
          return followedSearch.frequency === frequency.name
        })
      }
    }
  },
  beforeMount () {
    if (this.$user.isBasic()) {
      this.frequencies.forEach((frequency) => {
        if (frequency.name !== '3_MONTH') {
          frequency.disabled = true
        }
      })

      this.searchTypes.forEach((type) => {
        if (type.name === 'Patent') {
          type.disabled = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/EditFollowedSearch.vue